import React from 'react';
import TituloMuroLambrinSintetico from '../components/sections/MuroLambrinSintetico/TituloMuroLambrinSintetico'; 
import IntroLambrinSintetico from '../components/sections/MuroLambrinSintetico/IntroLambrinSintetico'; 
import DescripcionLambrin from '../components/sections/MuroLambrinSintetico/DescripcionLambrin'; 
import AplicacionesLambrin from '../components/sections/MuroLambrinSintetico/AplicacionesLambrin';
import PorQueLambrin from '../components/sections/MuroLambrinSintetico/PorQueLambrin'; 
import FormularioContactoLambrin from '../components/sections/MuroLambrinSintetico/FormularioContactoLambrin'; 
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

const MuroLambrinSinteticoPage = () => {
  return (
    <div>
      <Header />
        <TituloMuroLambrinSintetico /> 
        <IntroLambrinSintetico />   
        <DescripcionLambrin />  
        <AplicacionesLambrin />
        <PorQueLambrin /> 
        <FormularioContactoLambrin />
      <Footer />
    </div>
  );
};

export default MuroLambrinSinteticoPage;